import PropTypes from 'prop-types'
import { createContext, useState } from 'react'

export const SelectProductContext = createContext()

export const ProductProvider = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState(null)

  return (
    <SelectProductContext.Provider value={{ selectedProduct, setSelectedProduct }}>
      {children}
    </SelectProductContext.Provider>
  )
}

ProductProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
